import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getCollections(status) {
    const params = { status };
    const url = '/product_collections';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getCollection(id) {
    return api.get(`/product_collections/${id}`);
  },
  hideCollection(id) {
    return api.delete(`/product_collections/${id}`);
  },
  deleteCollection(id) {
    return api.delete(`/product_collections/${id}/delete`);
  },
  restoreCollection(id) {
    return api.put(`/product_collections/${id}/reactivate`);
  },
  updateCollection(id, payload) {
    return api.put(`/product_collections/${id}`, {
      product_collection: payload,
    });
  },
  updateOrderCollection(payload) {
    return api.put(`/product_collections/update_order`, {
      product_collections: payload,
    });
  },
  createCollection(payload) {
    return api.post(`/product_collections`, { product_collection: payload });
  },
  getProductList(
    page,
    q = '',
    sort_by = 'created_at desc',
    limit = '10',
    minPrice,
    maxPrice
  ) {
    const params = {
      cursor: page,
      limit,
      q,
      sort_by,
      min_price: minPrice,
      max_price: maxPrice,
      status: 'active',
    };
    const url = '/product_collections/products';

    return api.get(url, { params: omitBy(params, isNil) });
  },
};
